import React from 'react';
import '../css/task.css'
import NoteBlock from '../components/NoteBlock';
import Store from '../store/Store';
import { useNavigate, useParams } from 'react-router-dom';


const NoteList = () => {
    const { tableId } = useParams(); // Az URL-ből kapott ID
    const { tasks, tables, user } = Store.getState(); 

    const numericId = parseInt(tableId); // A route paraméter string, konvertáljuk

    let item = tables.find(t => t.table_id === numericId);
    let type = 'table';

    if (!item) {
        item = tasks.find(t => t.id === numericId);
        type = 'task';
    }    

    let navigate = useNavigate(); 
    const goBack = (item, type) =>{ 
        // let path = type==="table" ? '/table/'+item.table_id : '/edit-task/'+item.guid ; 
        // console.log(path);
        // navigate(path);
        navigate(-1);
    }    
    
    const renderHead = () => (
        <div className="page-head mt-2 mb-3 d-flex text-start">
            <h3 className="title"><strong>{item ? item.name : ""}</strong></h3>
            <div>
                <button onClick={() => goBack(item, type)} className="btn button" style={{whiteSpace: "nowrap"}}>{"< Vissza"}</button>
            </div>
        </div>
    );

    return (
        <div>
            {renderHead()}
            {!item ? (
                <strong>Ismeretlen azonosító!</strong>
            ) : (
                <NoteBlock 
                    name={type}  // task vagy table
                    notes={item.notes} 
                    cardClass={"task mb-2 mt-3 " + (type==="table" ? 'tablenotelist' : '')}
                    parentItem={item}
                    limit={0} // összes megjegyzés megjelentése
                    newNoteAllowed={false}
                    user={user}
                />
            )}
        </div>
    );
};

export default NoteList;
